const TaskIcon = ({ color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<path
				d="M20.5858 13.4142C21.3668 12.6332 21.3668 11.3668 20.5858 10.5858L13.4142 3.41421C12.6332 2.63317 11.3668 2.63316 10.5858 3.41421L3.41421 10.5858C2.63317 11.3668 2.63316 12.6332 3.41421 13.4142L10.5858 20.5858C11.3668 21.3668 12.6332 21.3668 13.4142 20.5858L20.5858 13.4142Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinejoin="round"
			></path>
		</svg>
	);
};

export default TaskIcon;
